import React from 'react';

import { Checkbox } from 'app/shared/components/atoms';

import { Option, SharedOptionsProps } from '.';

export interface MultiSelectOptionsProps<T> extends SharedOptionsProps<T> {
  onOptionClick: (option: T) => void;
  selectedOptions?: (string | number)[];
  displayBottomBorderOnLastChild?: boolean;
}

export const MultiSelectOptions = <T = any,>({
  onOptionClick,
  options,
  getOptionLabel,
  getOptionValue,
  invertColors,
  selectedOptions,
  displayBottomBorderOnLastChild = false,
}: MultiSelectOptionsProps<T>) => {
  const optionsList = options.map((option: T, index: number) => {
    const value = getOptionValue(option);
    const label = getOptionLabel(option);
    const isSelected = selectedOptions?.includes(value);

    return (
      <Option
        data-qaid={label}
        key={index}
        value={value}
        onClick={() => onOptionClick(option)}
        invertColors={invertColors}
        isLastChild={
          !displayBottomBorderOnLastChild && index === options.length - 1
        }
        gap={2}
      >
        <Checkbox
          id={`checkbox-${value}`}
          name={`checkbox-${value}`}
          key={index}
          checked={!!isSelected}
          onChange={() => onOptionClick(option)}
          invertColors={invertColors}
        >
          {label}
        </Checkbox>
      </Option>
    );
  });

  return <>{optionsList}</>;
};

export default MultiSelectOptions;
